  <app-classroom-form
    [classroom]="classroom"
    (saved)="onSaved($event)"
    (canceled)="onCanceled()">
  </app-classroom-form>
